import { Component, inject } from '@angular/core';
import { NavigatorComponent } from '../../components/navigator/navigator.component';
import { ButtonModule } from 'primeng/button';
import { PlaylistService } from '../../services/playlist.service';

@Component({
  selector: 'remote',
  templateUrl: './remote.component.html',
  styleUrl: './remote.component.scss',
  imports: [NavigatorComponent, ButtonModule]
})
export class RemoteComponent {
  private playlistService = inject(PlaylistService);

  playNext() {
    this.playlistService.requestNextSong().subscribe({
      next: () => console.log('📡 Next song signal sent'),
      error: err => console.error('❌ Failed to send next song signal:', err),
    });
  }

  playPrevious() {
    this.playlistService.requestPreviousSong().subscribe({
      next: () => console.log('📡 Previous song signal sent'),
      error: err =>
        console.error('❌ Failed to send previous song signal:', err),
    });
  }

  selectSong() {
    console.log('It should open current playlist and show me que. When I click on a song, it should set the playlist position to that song.');
  }
}
